var _defs, _circle, _circle2, _g, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFballloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "-105 -105 210 210",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ball"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 100,
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shadow1",
    cx: 0.4,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EEEEEE",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shadow2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "black",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "black",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "black_stuff",
    strokeLinejoin: "round",
    clipPath: "url(#ball)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "black"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6,-32 Q 26,-28 46,-19 Q 57,-35 64,-47 Q 50,-68 37,-76 Q 17,-75 1,-68 Q 4,-51 6,-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -26,-2 Q -45,-8 -62,-11 Q -74,5 -76,22 Q -69,40 -50,54 Q -32,47 -17,39 Q -23,15 -26,-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -95,22 Q -102,12 -102,-8 V 80 H -85 Q -95,45 -95,22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55,24 Q 41,41 24,52 Q 28,65 31,79 Q 55,78 68,67 Q 78,50 80,35 Q 65,28 55,24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,120 L -3,95 Q -25,93 -42,82 Q -50,84 -60,81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -90,-48 Q -80,-52 -68,-49 Q -52,-71 -35,-77 Q -35,-100 -40,-100 H -100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100,-55 L 87,-37 Q 98,-10 97,5 L 100,6"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6,-32 Q -18,-12 -26,-2                      M 46,-19 Q 54,5 55,24                      M 64,-47 Q 77,-44 87,-37                      M 37,-76 Q 39,-90 36,-100                      M 1,-68 Q -13,-77 -35,-77                      M -62,-11 Q -67,-25 -68,-49                      M -76,22 Q -85,24 -95,22                      M -50,54 Q -49,70 -42,82                      M -17,39 Q 0,48 24,52                      M 31,79 Q 20,92 -3,95                      M 68,67 L 80,80                      M 80,35 Q 90,25 97,5             "
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 100,
    fill: "white",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 100,
    fill: "url(#shadow1)",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: 0,
    to: 360,
    begin: "0s",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#black_stuff",
    stroke: "#EEE",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#black_stuff",
    stroke: "#DDD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#black_stuff",
    stroke: "#999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#black_stuff",
    stroke: "black",
    strokeWidth: 1
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 100,
    fill: "url(#shadow2)",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFballloader);
export default __webpack_public_path__ + "static/media/fballloader.96899988184baa7f5641483e36f9ed82.svg";
export { ForwardRef as ReactComponent };